import { gql } from "@apollo/client";
export const USERSAPP = gql`
  query USERSAPP(
    $search: String
    $rols_ids: [String!]
    $first: Int
    $last: Int
    $company_id: String
  ) {
    users(
      where: {
        OR: [
          { email: { contains: $search } }
          { nickname: { contains: $search } }
          { names: { contains: $search } }
          { lastnames: { contains: $search } }
        ]
        AND: [
          { company_id: { equals: $company_id } }
          { roles_aplication: { some: { rol_id: { in: $rols_ids } } } }
        ]
      }
      first: $first
      last: $last
    ) {
      id
      email
      nickname
      names
      company {
        name
        id
      }
      lastnames
      status
      notificationUser
      companies_assing
      telephone
      last_login
      verification
      roles_aplication(where: { deleted_at: { equals: null } }) {
        id
        deleted_at
        company {
          id
          name
        }
        applications {
          id
          name
        }
        rols {
          id
          name
        }
      }
    }
  }
`;

export const USERSDATA = gql`
  fragment combouser on user {
    id
    nickname
  }
  fragment tableuser on user {
    id
    email
    nickname
    names
    lastnames
    status
    roles_aplication {
      id
      company {
        id
        name
      }
      applications {
        id
        name
      }
      rols {
        id
        name
      }
    }
  }
  query USERSDATA(
    $search: String
    $first: Int
    $last: Int
    $combo: Boolean!
    $table: Boolean!
  ) {
    users(
      where: {
        OR: [
          { email: { contains: $search } }
          { nickname: { contains: $search } }
          { names: { contains: $search } }
          { lastnames: { contains: $search } }
        ]
        AND: [
          {
            roles_aplication: {
              some: { AND: [{ application_id: { equals: "2" } }] }
            }
          }
        ]
      }
      first: $first
      last: $last
    ) {
      ...combouser @include(if: $combo)
      ...tableuser @include(if: $table)
    }
  }
`;

export const ALLUSERS = gql`
  query ALLUSERS($search: String, $first: Int, $last: Int) {
    userss(
      where: { nickname: { contains: $search } }
      first: $first
      last: $last
    ) {
      id
      nickname
    }
  }
`;

export const MUTATIONRESTOREPASSWORD = gql`
  mutation MUTATIONRESTOREPASSWORD(
    $oldPassword: String!
    $newPassword: String!
    $userId: String!
    $currentSessionId: String
    $applicationId: String
  ) {
    updateUserPassword(
      updatePasswordInput: {
        oldPassword: $oldPassword
        newPassword: $newPassword
        userId: $userId
        currentSessionId: $currentSessionId
        applicationId: $applicationId
      }
    )
  }
`;

export const WHITElISTPLACE = gql`
  query WHITElISTPLACE($id: String) {
    userss(where: { id: { equals: $id } }) {
      id
      names
      whiteList
    }
  }
`;

export const RESTOREPASSWORDTABLE = gql`
  mutation RESTOREPASSWORDTABLE($user: String) {
    restorePasswordTable(user: $user)
  }
`;

export const USERPERMISSIONSETTING = gql`
  query USERPERMISSIONSETTING($id: String) {
    users(where: { id: { equals: $id } }) {
      permission_setting
    }
  }
`;

export const USERSCONFIGPAYMENT = gql`
  query USERSCONFIGPAYMENT {
    digitadors(
      where: { deleted_at: { equals: null }, type: { equals: "PAGO" } }
    ) {
      user {
        id
        names
        lastnames
        nickname
      }
    }
  }
`;

export const USERCOMPANYACCESSNOTVERTEBRA = gql`
  query USERCOMPANYACCESSNOTVERTEBRA($id: String) {
    users(where: { id: { equals: $id } }) {
      roles_aplication(
        where: {
          application_id: { equals: "2" }
          deleted_at: { equals: null }
          company_id: { not: { equals: "cqzqzv50bir5dtgz0pi33oy"}  }
        }
      ) {
        company {
          id
          name
        }
      }
    }
  }
`;

export const GET_USER_PRIVACY = gql`
  query GET_USER_PRIVACY($id: String) {
    users(where: { id: { equals: $id } }) {
      id
      extras
    }
  }
`;

export const GET_USER_SETTING = gql`
  query GET_USER_SETTING($id: String!) {
    userss(where: { id: { equals: $id } }) {
      setting
    }
  }
`;

export const UPDATE_USER_EXTRAS = gql`
  mutation UPDATE_USER_EXTRAS($id: String!, $data: userUpdateInput!) {
    updateOneuser(data: $data, where: { id: $id }) {
      id
    }
  }
`;
